
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/integra-ai",
      function () {
        return require("private-next-pages/products/integra-ai/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/integra-ai"])
      });
    }
  